import type { Country } from '@tectonics/prs/country';
import { getOrThrow } from '@tectonics/utils/getters';

const BASE_DEBIT_CARD_BRANDS: readonly string[] = ['visa', 'mastercard'];

const BRAZILIAN_DEBIT_CARD_BANKS: readonly string[] = [
  'nubank',
  'santander',
  'bancodobrasil',
  'caixa',
  'bradesco',
  'original',
  'inter',
  'c6',
  'bancoob',
  'bancopan',
  'sicredi',
  'agibank',
  'bancobmg',
  'brb',
  'itau',
];

const DEBIT_CARD_BRANDS_BY_COUNTRY: Readonly<Partial<Record<Country, readonly string[]>>> = {
  br: BRAZILIAN_DEBIT_CARD_BANKS,
  uy: ['visa'],
  py: [...BASE_DEBIT_CARD_BRANDS, 'infonet'],
  ar: BASE_DEBIT_CARD_BRANDS,
  cl: BASE_DEBIT_CARD_BRANDS,
  pe: BASE_DEBIT_CARD_BRANDS,
  pa: BASE_DEBIT_CARD_BRANDS,
  sv: BASE_DEBIT_CARD_BRANDS,
  gt: BASE_DEBIT_CARD_BRANDS,
  do: BASE_DEBIT_CARD_BRANDS,
  cr: BASE_DEBIT_CARD_BRANDS,
  ke: BASE_DEBIT_CARD_BRANDS,
  ng: [...BASE_DEBIT_CARD_BRANDS, 'verve'],
  za: BASE_DEBIT_CARD_BRANDS,
  eg: [...BASE_DEBIT_CARD_BRANDS, 'meeza'],
  co: [...BASE_DEBIT_CARD_BRANDS, 'diners'],
  ec: [...BASE_DEBIT_CARD_BRANDS, 'diners'],
  in: [...BASE_DEBIT_CARD_BRANDS, 'rupay'],
  jm: BASE_DEBIT_CARD_BRANDS,
};

export function getDebitCardBrandsForCountry(country: Country): readonly string[] {
  const brands = getOrThrow(
    Object.prototype.hasOwnProperty.call(DEBIT_CARD_BRANDS_BY_COUNTRY, country)
      ? DEBIT_CARD_BRANDS_BY_COUNTRY[country]
      : undefined,
    `getDebitCardBrandsForCountry - there is no debit card brands implementation for country "${country}".`
  );

  return [...brands];
}
